import { mapState } from 'vuex'
import { throttle, isEqual } from 'lodash-es'

import { EventBus } from '@/utils/event-bus'
import {
  IPHONE_KEYS,
  SETTINGS_KEYS,
  ALL_KEYS
} from '@/utils/keys'

export default () => {
  let updateOnMount = false
  const watch = {}
  const settingsComputed = {}

  ALL_KEYS.forEach(key => {
    if (!updateOnMount && IPHONE_KEYS.includes(key)) {
      updateOnMount = true
    }

    watch[key] = {
      handler: throttle(function (newVal, oldVal) {
        const db = this.$store.state.db[key]
        const newAndDbSame = isEqual(newVal, db)

        this.$store.commit('UPDATE_PREVIEW_CHANGE', {
          type: key,
          changed: !newAndDbSame
        })

        if (IPHONE_KEYS.includes(key)) {
          EventBus.$emit('update-iphone', key)
        }
      }, 250),
      deep: true
    }
  })

  SETTINGS_KEYS.forEach(key => {
    settingsComputed[key] = function () {
      return this.settings[key]
    }
  })

  return {
    mounted: function () {
      if (updateOnMount) {
        EventBus.$emit('update-iphone')
      }
    },
    computed: {
      ...mapState([ 'previewChange', 'amptheme', 'settings' ]),
      ...settingsComputed,
      hasChanged: function () {
        return Object.keys(this.previewChange).some(type => this.previewChange[type])
      }
    },
    watch
  }
}
